import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import user from './modules/user'
import robot from './modules/robot'
import chatbot from './modules/chatbot'
import getters from './getters'
import permission from './modules/permission'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    permission,
    user,
    robot,
    chatbot
  },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js